




















import {
    State,
    Action,
    Getter,
    Mutation
} from "vuex-class";
import {
    Component,
    Prop,
    Vue
} from 'vue-property-decorator';
import {
    pageDataType
} from "../types";
import {
    HOST
} from "../global";
import {
    TweenMax,
    TimelineLite,
    Power3,
    Power4,
    Power2,
    TimelineMax,
} from 'gsap';

// const plugins = [ScrollToPlugin];
import ScrollMagic from "scrollmagic";
import gsap from 'scrollmagic';
@Component({
    name: "IndustryTextimg"
})
export default class IndustryTextimg extends Vue {
    @Prop() readonly compData!: any;
    public HOST: string = HOST;
    @Prop() public controller!: any | null;
    @Prop() public controller1!: any | null;

    public mounted() {

        const tl1 = new TimelineMax()
            .from('.industrytext-details p', 1, {
                scale: .8,
                y: '20%',
                opacity: 0,
                ease: Power2.easeOut
            })

        const controller = new ScrollMagic.Controller();

        const scene = new ScrollMagic.Scene({
                triggerElement: ".industrytext-details p",
                reverse: false,
                // duration: 1000,
                //triggerHook: "onEnter"
            })
            .setTween(tl1)
            .addTo(controller);

        const tl2 = new TimelineMax()
            .from('.right', 1, {
                force3D: true,
                autoAlpha: 0,
                overflow: "hidden",
                x: '100%',
                ease: Power2.easeInOut,
                scale: 1.35
            })
    const controller1 = new ScrollMagic.Controller();

    const scene1 = new ScrollMagic.Scene({
            triggerElement: ".right",
            reverse: false,
            //triggerHook: "onEnter"
        })
        .setTween(tl2)
        .addTo(controller1);

}
}
